import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Calendar } from "../Calendar";
export var CalendarView = function () {
    return (_jsx(React.Fragment, { children: _jsx(Calendar, {}) }));
};
